import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { useFeatures } from 'reaxl-features';
import { specificationsIconMap, tabsIconMap } from './iconMap';
function Icon(_ref) {
  let {
    icon,
    label,
    height = 25,
    width = 30,
    iconSet,
    highlightIcon = false
  } = _ref;
  const {
    icons: [, {
      icon_url: iconUrl = '//www.autotrader.com/content/static/img/icon/specifications/all_icons_orange.svg',
      highlighted_icon_url: highlightedIconUrl
    }]
  } = useFeatures(['icons']);
  let iconSrc = highlightIcon && highlightedIconUrl ? highlightedIconUrl : iconUrl;
  let iconMap = specificationsIconMap;
  if (iconSet === 'tabs') {
    iconSrc = '//www.autotrader.com/content/static/img/icon/tabs/category_icons_orange.svg';
    iconMap = tabsIconMap;
  }
  const getIconCoordinates = iconName => iconMap[iconName];
  return /*#__PURE__*/_jsx("div", {
    "aria-label": label,
    role: "img",
    style: {
      background: icon ? `url(${iconSrc}) ${getIconCoordinates(icon)}` : '',
      height,
      width
    }
  });
}
export default Icon;